import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { NavigationService } from '../services/navigation.service';

// store
import { AppState } from '../app-reducer';
import { Store } from '@ngrx/store';

// reactive
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { ProcessorService } from './processor.service';

@Injectable({
    providedIn: 'root'
  })
  export class CommonService {
  appState$: Observable<any>;
  isProduction: boolean;
  constructor(
    private navigationService: NavigationService,
    private processorService: ProcessorService,

    private router: Router,
    private store: Store<AppState>,
  ) {
    this.appState$ = this.store.select('sections');
    this.isProduction = this.processorService.isProduction();
  }

  toMMSS(sec_num) {
    const hours   = Math.floor(sec_num / 3600);
    const minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    const seconds = sec_num - (hours * 3600) - (minutes * 60);

    const _hours= (hours   < 10) ? "0"+hours : hours;
    const _minutes = (minutes < 10) ? "0"+minutes : minutes;
    const _seconds = (seconds < 10) ? "0"+seconds : seconds;
     return _minutes+':'+_seconds;
  }

  logAppState(state) {
    if (!this.isProduction) {
      console.log('⥉ appState$', state);      
    }
  }

  logMessage(msg, object?) {
    if (!this.isProduction) {
      if (object){
        console.log(msg, object);  
      }else {
        console.log(msg);    
      }
    }
  }
}
